<div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h1 pr-16">Sucursales</div>
    </div>
    <mat-form-field>
        <span matPrefix>
            <mat-icon>search</mat-icon>
        </span>
        <input matInput #filter placeholder="Buscar..." />
    </mat-form-field>
    <div class="contenedor-tabla">
        <mat-table
            class="servicios-tabla"
            #table
            [dataSource]="dataSource"
            matSort
            [@animateStagger]="{ value: '50' }"
            fusePerfectScrollbar
        >
            <ng-container matColumnDef="nombre">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Nombre</mat-header-cell
                >
                <mat-cell *matCellDef="let sucursal">
                    {{ sucursal.nombre }}
                    <button
                        *ngIf="esRepresentante || esSupervisor"
                        mat-icon-button
                        type="button"
                        color="accent"
                        (click)="editar(sucursal)"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <!-- ng-container matColumnDef="rutFacturacion">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Rut Facturación</mat-header-cell
                >
                <mat-cell *matCellDef="let sucursal">
                    <p>
                        {{ sucursal.cliente.rut }}
                    </p>
                </mat-cell>
            </ng-container -->

            <ng-container matColumnDef="direccion">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Dirección</mat-header-cell
                >
                <mat-cell *matCellDef="let sucursal">
                    <p>
                        {{ sucursal.direccion }} -
                        {{ sucursal.comuna.nombre }} -
                        {{ sucursal.comuna.region.nombre }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="telefono">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Teléfono</mat-header-cell
                >
                <mat-cell *matCellDef="let sucursal">
                    <p>
                        {{ sucursal.telefono }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="borrar" *ngIf="esRepresentante || esSupervisor">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Borrar</mat-header-cell
                >
                <mat-cell *matCellDef="let sucursal">
                    <p>
                        <button
                            mat-icon-button
                            type="button"
                            color="accent"
                            (click)="borrar(sucursal.id)"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <mat-header-cell *matHeaderCellDef>Encargados</mat-header-cell>
                <mat-cell *matCellDef="let sucursal">
                    <a
                        [routerLink]="
                            '../encargados/' +
                            sucursal.id +
                            '/' +
                            sucursal.cliente.id
                        "
                        >VER ENCARGADOS</a
                    >
                    <!-- button
                        *ngIf="esRepresentante"
                        mat-button
                        type="button"
                        color="accent"
                        (click)="verEncargados(sucursal.id)"
                    >
                        {{ "Ver Encargados" | uppercase }}
                    </button -->
                </mat-cell>
            </ng-container>

            <mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>

            <mat-row *matRowDef="let sucursal; columns: displayedColumns">
            </mat-row>
        </mat-table>
        <mat-paginator
            #paginator
            [length]="dataSource?.filteredData?.length"
            [pageIndex]="0"
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 25, 100]"
        >
        </mat-paginator>
    </div>
</div>
